module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN335_976968305.8b9f72ce.png";